import bootstrapSite from '../app/bootstrapSite';
import getMarkersApiArgs from '../components/Map/utilities/getMarkersApiArgs';
import { getPropertyFromUrl } from '../components/Map/utilities/getPropertyFromUrl';

bootstrapSite();

window.addEventListener('load', () => {
    const reactModule = import(/* webpackChunkName: "React" */ 'react');
    const reactDomModule = import(/* webpackChunkName: "react-dom" */ 'react-dom');
    const MapModule = import(/* webpackChunkName: "MapWithMarkers" */ '../components/Map');

    Promise.all([reactModule, reactDomModule, MapModule]).then((response) => {
        const [React, { render }, { MapWithMarkers }] = response;

        const FULL_MAP_ZOOM = 2;
        const mapBox = document.querySelector('.j-map-box');
        const initialLatitude = parseFloat(mapBox.getAttribute('data-latitude'));
        const initialLongitude = parseFloat(mapBox.getAttribute('data-longitude'));
        const initialZoom = parseFloat(mapBox.getAttribute('data-zoom'));
        const propertyType = mapBox.getAttribute('data-prop');

        // recalculated the coordinates and zoom when displaying the whole earth map
        const zoom = initialZoom === FULL_MAP_ZOOM ? initialZoom - 0.4 : initialZoom - 1;
        const latitude = initialLatitude === 0 ? initialLatitude + 15 : initialLatitude;
        const longitude = initialLongitude === 0 ? initialLongitude + 10 : initialLongitude;

        const tags = mapBox.getAttribute('data-searchTags').split('|');
        const markersAndMapType = getMarkersApiArgs(tags, propertyType);
        const filterOptions = {
            show: true,
            propertyType: getPropertyFromUrl()
        };

        render(
            <div className="map-area">
                <MapWithMarkers
                    latitude={latitude}
                    longitude={longitude}
                    zoom={zoom}
                    mapType={markersAndMapType.mapType}
                    showFilters={filterOptions}
                    markersApiArgs={markersAndMapType.mapWithArgs}
                    isDragDisabled={true}
                />
            </div>,
            mapBox
        );
    });
});
